import { useIntl } from "@/infra/locale";
import { WebshopHeader } from "../layout/WebshopHeader";
import { PhysiotherapistCard } from "./PhysiotherapistCard";
import { ProgramCard } from "./ProgramCard";

type SpecifiedPlanViewProps = {
  treatmentName: string;
};

export function SpecifiedPlanView({ treatmentName }: Readonly<SpecifiedPlanViewProps>) {
  const { formatMessage } = useIntl();

  return (
    <div className="flex w-full flex-col gap-8">
      <WebshopHeader
        title={formatMessage(
          { id: "checkoutPage.resultStep.specifiedTherapyPlan.title" },
          { therapyPlan: treatmentName },
        )}
        subtitle={formatMessage({ id: "checkoutPage.resultStep.specifiedTherapyPlan.subtitle" })}
      />

      <div className="overflow-hidden rounded-4xl bg-white p-6">
        <div className="flex flex-col gap-4 lg:flex-row lg:items-stretch lg:gap-8">
          <div className="flex flex-1 flex-col">
            <ProgramCard />
          </div>
          <div className="flex w-full flex-col lg:w-106.75">
            <PhysiotherapistCard />
          </div>
        </div>
      </div>
    </div>
  );
}
